import React from 'react';
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { ROLES } from '../constants/layout';
import PaymentIntegrations from '../pages/PaymentSettings/components/PaymentIntegrations';
import ReportingTable from '../pages/Reports';
import TodayBookings from '../pages/TodayBookings';
import SmsEmailReport from '../pages/Sms-Email-Report';
import GoogleCalendarCallback from '../pages/GoogleCalendarCallback';
import AllTimeFees from '../pages/AllTimeFees';
import MicrosoftCalendarCallback from '../pages/MicrosoftCalendarCallback';
import AppFee from '../pages/AppFee';
import PlanDetail from '../pages/pricingPlanDetails';
import ApiLogs from '../pages/LokiLogs';
import VerifyEmail from '../pages/VerifyEmail'
import VerifyInvite from '../pages/VerifyInvite';
import Signup from '../pages/Authentication/subscriptionRegsiter';
import CompletePaymentLog from '../pages/CompletePaymentLog';
import SearchEngine from '../pages/SearchEngine';
const DentallyReport = lazy(async () => await import('../pages/DentallyReport'));
const AllTimeBusinessRevenueReport = React.lazy(
  () => import('../pages/allTimeBusinessRevenueReport')
);
const Login = React.lazy(() => import('../pages/Authentication/Login'));
const Register = React.lazy(() => import('../pages/Authentication/Register'));
const Logout = React.lazy(() => import('../pages/Authentication/Logout'));
const ForgetPwd = React.lazy(() => import('../pages/Authentication/ForgetPassword'));
const Dashboard = lazy(async () => await import('../pages/Dashboard/index'));
const Appointment = lazy(async () => await import('../pages/Appointment/index'));
const ChooseLocation = lazy(async () => await import('../pages/ChooseLocation'));
const PatientInfo = lazy(async () => await import('../pages/PatientInfo'));
const CardPayment = lazy(async () => await import('../pages/CardPayment'));
const AppointmentSummary = lazy(async () => await import('../pages/AppointmentSummary'));
const Calendar = lazy(async () => await import('../pages/Calendar'));
const Patients = lazy(async () => await import('../pages/Patients'));
const Services = lazy(async () => await import('../pages/Services'));
const PatientDetail = lazy(async () => await import('../pages/PatientDetail'));
const BussinessSettings = lazy(async () => await import('../pages/BussinessSettings'));
const AppointmentAdmin = lazy(async () => await import('../pages/Appointment-Admin'));
const AppointmentAdminDetail = lazy(async () => await import('../pages/AdminAppointmentDetails'));
const AppointmentSettings = lazy(async () => await import('../pages/AppointmentSettings'));
const Locations = lazy(async () => await import('../pages/Locations'));
const Business = lazy(async () => await import('../pages/business'));
const PaymentSettings = lazy(async () => await import('../pages/PaymentSettings'));
const Callback = lazy(async () => await import('../pages/SquarePay-Auth-Callback/callback'));
const Admins = lazy(async () => await import('../pages/Admins'));
const PlatformUsers = lazy(async () => await import('../pages/PlatformUsers'));
const Integrations = lazy(async () => await import('../pages/Integrations'));
const Cancellation = lazy(async () => await import('../pages/cancellationPolicy'));
const BusinessDetail = lazy(async () => await import('../pages/businessDetail'));
const PaymentLogs = lazy(async () => await import('../pages/PaymentsLogs'));
const Payments = lazy(async () => await import('../pages/Payments'));
const Refunds = lazy(async () => await import('../pages/Refunds'));
const DashboardBusinessAdmin = lazy(async () => await import('../pages/Dashboard-Business-Admin'));

const UserProfile = lazy(async () => await import('../pages/Authentication/user-profile'));
const Landing = lazy(async () => await import('../pages/landing'));
const DashboardList = lazy(async () => await import('../pages/dashboardList'));
const PrivacyPolicy = lazy(async () => await import('../pages/TermsAndCondition'));
const Notification = lazy(async () => await import('../pages/Notifications'));
const BookDemo = lazy(async () => await import('../pages/BookDemo'));
const ContactUs = lazy(async () => await import('../pages/Contactus'));
import BusinessAccess from '../pages/BusinessAccess';
import Terms from '../pages/terms';
import AdminLocationBillingDetail from '../pages/AdminLocationBillingDetail';

const authProtectedRoutes = [
  {
    path: '/dashboardlist',
    role: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.BUSINESS_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <DashboardList />
  },
  {
    path: '/dashboardlist/locationdashboard',
    role: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.BUSINESS_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <Dashboard />
  },
  {
    path: '/dashboardlist/businessdashboard',
    role: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.BUSINESS_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <DashboardBusinessAdmin />
  },
  {
    path: '/dashboard-business-admin',
    role: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.BUSINESS_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <DashboardBusinessAdmin />
  },
  {
    path: '/calender',
    role: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.BUSINESS_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <Calendar />
  },
  {
    path: '/customers',
    role: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.BUSINESS_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <Patients />
  },
  {
    path: '/adminAppointment',
    role: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.BUSINESS_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <AppointmentAdmin />
  },
  {
    path: '/adminAppointment/:id',
    role: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.BUSINESS_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <AppointmentAdminDetail />
  },
  {
    path: '/reports/todayBookingsReport',
    role: [ROLES.SUPER_ADMIN, ROLES.BUSINESS_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <TodayBookings />
  },
  {
    path: '/reports/smsemailreport',
    role: [ROLES.SUPER_ADMIN, ROLES.BUSINESS_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <SmsEmailReport />
  },
  {
    path: '/reports/revenuereport',
    role: [ROLES.SUPER_ADMIN, ROLES.BUSINESS_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <AllTimeBusinessRevenueReport />
  },
  {
    path: '/reports/alltimefees',
    role: [ROLES.SUPER_ADMIN, ROLES.BUSINESS_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <AllTimeFees />
  },
  {
    path: '/reports/completepaymentlog',
    role: [ROLES.SUPER_ADMIN, ROLES.BUSINESS_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <CompletePaymentLog />
  },
  {
    path: '/reports/dentallyreport',
    role: [ROLES.SUPER_ADMIN, ROLES.BUSINESS_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <DentallyReport />
  },
  {
    path: '/services',
    role: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.BUSINESS_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <Services />
  },
  {
    path: '/paymentlogs',
    role: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.BUSINESS_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <PaymentLogs />
  },
  {
    path: '/customers/:id',
    role: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.BUSINESS_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <PatientDetail />
  },
  {
    path: '/business/:id',
    role: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.BUSINESS_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <BusinessDetail />
  },
  {
    path: '/business-settings',
    role: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.BUSINESS_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <BussinessSettings />
  },
  {
    path: '/appointment-settings',
    role: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.BUSINESS_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <AppointmentSettings />
  },
  {
    path: '/locations',
    role: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.BUSINESS_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <Locations />
  },
  {
    path: '/business',
    role: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.BUSINESS_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <Business />
  },
  {
    path: '/allbusiness',
    role: [ROLES.SUPER_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <Business />
  },
  {
    path: '/payment-settings/*',
    role: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.BUSINESS_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <PaymentSettings />
  },
  {
    path: '/refunds',
    role: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.BUSINESS_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <Refunds />
  },
  {
    path: '/adminlocationbillingdetails',
    role: [ROLES.SUPER_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <AdminLocationBillingDetail />
  },
  //profile
  {
    path: '/profile',
    role: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.BUSINESS_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <UserProfile />
  },
  {
    path: '/payments',
    role: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.BUSINESS_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <Payments />
  },
  {
    path: '/users',
    role: [ROLES.SUPER_ADMIN, ROLES.BUSINESS_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <Admins />
  },
  {
    path: '/platformusers',
    role: [ROLES.SUPER_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <PlatformUsers />
  },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: '/',
    exact: true,
    role: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.BUSINESS_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <Navigate to="/calender" />
  },
  {
    path: '/integration-settings',
    exact: true,
    role: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.BUSINESS_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <PaymentIntegrations />
  },
  {
    path: '/integrations',
    role: [ROLES.SUPER_ADMIN, ROLES.BUSINESS_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <Integrations />
  },
  {
    path: '/reports',
    role: [ROLES.SUPER_ADMIN, ROLES.BUSINESS_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <ReportingTable />
  },
  {
    path: '/notifications',
    role: [ROLES.SUPER_ADMIN, ROLES.BUSINESS_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <Notification />
  },
  {
    path: '/businessAccess',
    role: [ROLES.SUPER_ADMIN, ROLES.BUSINESS_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <BusinessAccess />
  },
  {
    path: '/appfees',
    role: [ROLES.SUPER_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <AppFee />
  },
  {
    path: '/apilogs',
    role: [ROLES.SUPER_ADMIN, ROLES.PLATFORM_ADMIN],
    component: <ApiLogs />
  },
];

const BusinessDetails = lazy(async () => await import('../pages/Authentication/BusinessDetails'));
const AppointmentNotFound = lazy(async () => await import('../pages/AppointmentNotFound'));

const publicRoutes = [
  { path: '/', component: <Landing /> },
  { path: '/business-details', component: <BusinessDetails /> },
  { path: '/appointment', component: <Appointment /> },
  { path: '/choose-location', component: <ChooseLocation /> },
  { path: '/patientinfo', component: <PatientInfo /> },
  { path: '/cardpayment', component: <CardPayment /> },
  { path: '/summary', component: <AppointmentSummary /> },
  { path: '/logout', component: <Logout /> },
  { path: '/login', component: <Login /> },
  { path: '/forgot-password', component: <ForgetPwd /> },
  { path: '/google/callback', component: <GoogleCalendarCallback /> },
  { path: '/microsoft/callback', component: <MicrosoftCalendarCallback /> },
  { path: '/callback', component: <Callback /> },
  { path: '/termsandconditions', component: <Cancellation /> },
  { path: '/appointment-notfound', component: <AppointmentNotFound /> },
  // { path: '/register', component: <Register /> },
  { path: '/forgotpassword', component: <ForgetPwd /> },
  { path: '/privacypolicy', component: <PrivacyPolicy /> },
  { path: '/plan/:planId', component: <PlanDetail /> },
  { path: '/verify', component: <VerifyEmail /> },
  { path: '/verifyInvite', component: <VerifyInvite /> },
  // test link for checking sale force integration
  { path: '/ReportIncident', component: <SearchEngine /> },

  // { path: '/signup', component: <Signup /> },
  
  { path: '/bookdemo', component: <BookDemo /> },
  { path: '/contactus', component: <ContactUs /> },

  //terms and privacy
  { path: '/terms', component: <Terms /> },
];

export { authProtectedRoutes, publicRoutes };
